// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__2E9OQ","darkTable":"recipe_darkTable__1spAl"};